/*
 * EXPORTS
 */
export default require('react').createContext()
